module.exports = __webpack_public_path__ + "img/24.07f00951.png";